import type { CSSProperties } from 'react'
import type { ProductCover } from '@/types'

/* Feeds a product's cover colors to the .kuro-cover styles in globals.css. */
export const coverStyle = (cover: ProductCover): CSSProperties => {
    return {
        '--cover-from': cover.from,
        '--cover-to': cover.to,
        '--cover-ink': cover.ink
    } as CSSProperties
}
